module.exports = __webpack_public_path__ + "img/multiplier_3_en.dff032c2.png";